/**
 * Signature font registry for the eSign adopt-signature picker.
 *
 * Each entry names a signature style. To use the EXACT premium font, drop its licensed
 * file into `public/fonts/signature/<file>.ttf` (or .woff2) — it then loads automatically.
 * Until a file is present, the style falls back to the closest free Google Font (`fallback`),
 * so the picker always shows visibly different styles.
 *
 * ⚠️ Many of the exact fonts below are "free for personal use" only. Confirm a commercial
 * licence before shipping them in the CRM.
 */

export const SIGNATURE_FONTS = [
  { label: 'Amalfi Coast', file: 'AmalfiCoast', fallback: 'Sacramento' },
  { label: 'Costella', file: 'Costella', fallback: 'Kaushan Script' },
  { label: 'Andellia Davilton', file: 'AndelliaDavilton', fallback: 'Allura' },
  { label: 'Bellisya Signature', file: 'BellisyaSignature', fallback: 'Great Vibes' },
  { label: 'Modernline', file: 'Modernline', fallback: 'Caveat' },
];

// CSS font stack: exact font first, then its Google fallback, then generic cursive.
export function fontStack(def) {
  return `'${def.label}', '${def.fallback}', cursive`;
}

const GOOGLE_HREF =
  'https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Caveat:wght@600&family=Dancing+Script:wght@600&family=Great+Vibes&family=Kaushan+Script&family=Pacifico&family=Qwitcher+Grypen&family=Sacramento&family=Satisfy&family=Shadows+Into+Light&family=Yellowtail&display=swap';

/** Inject the Google fallbacks + @font-face rules for any dropped-in exact fonts. */
export function ensureSignatureFonts() {
  if (typeof document === 'undefined') return;

  if (!document.getElementById('esign-google-signature-fonts')) {
    const link = document.createElement('link');
    link.id = 'esign-google-signature-fonts';
    link.rel = 'stylesheet';
    link.href = GOOGLE_HREF;
    document.head.appendChild(link);
  }

  if (!document.getElementById('esign-custom-signature-fonts')) {
    const base = `${process.env.PUBLIC_URL || ''}/fonts/signature`;
    const css = SIGNATURE_FONTS.map((f) => `
@font-face {
  font-family: '${f.label}';
  src: url('${base}/${f.file}.woff2') format('woff2'),
       url('${base}/${f.file}.otf') format('opentype'),
       url('${base}/${f.file}.ttf') format('truetype');
  font-display: swap;
}`).join('\n');
    const style = document.createElement('style');
    style.id = 'esign-custom-signature-fonts';
    style.textContent = css;
    document.head.appendChild(style);
  }
}
